var _path, _path2, _path3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,65 L30,20 Q50,0 70,20 L70,65 Z",
    fill: "#e60000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,65 L30,20 Q50,0 70,20 L70,65 Z",
    fill: "#660000",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35,25 Q50,10 65,25 L63,28 Q50,15 37,28 Z",
    fill: "#ff3333",
    opacity: 0.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 65,
    x2: 40,
    y2: 95,
    stroke: "#666666",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 65,
    x2: 60,
    y2: 95,
    stroke: "#666666",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedIcon);
export default __webpack_public_path__ + "static/media/led-icon.06a07212e4a577e8a664a4aa63857adb.svg";
export { ForwardRef as ReactComponent };